module.exports = require('./lib/devtool-hook.js');